import { useState, useEffect, useMemo } from 'react';
import { apiService } from '../services/api';
import { resolvePayerBillingConfig } from '../utils/payerBillingConfig';

// One fetch of the org's active payers per session, shared across all mounts.
// The endpoint is unpaginated and this same list is already loaded elsewhere
// on these screens (PatientDetails, PatientForm, eligibility views).
let payerListPromise = null;

// Exported so screens that need the raw active-payer list (e.g. the chart's
// insurance editor) share this cache instead of re-fetching.
export const fetchActivePayers = () => {
  if (!payerListPromise) {
    payerListPromise = apiService.getOrganizationPayers({ is_active: true })
      .then(data => (Array.isArray(data) ? data.filter(p => p.is_active) : []))
      .catch(() => {
        payerListPromise = null; // allow retry after a failed load
        return [];
      });
  }
  return payerListPromise;
};

export { resolveOrgPayer } from '../utils/payerBillingConfig';

// caseLoading prevents transient patient-primary rules while a selected case loads.
export function usePayerBillingConfig(patient, caseRow = null, { caseLoading = false } = {}) {
  const [payers, setPayers] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    fetchActivePayers().then(list => {
      if (!cancelled) { setPayers(list); setIsLoading(false); }
    });
    return () => { cancelled = true; };
  }, []);
  return useMemo(() => resolvePayerBillingConfig(patient, caseRow, payers || [], isLoading || caseLoading), [patient, caseRow, payers, isLoading, caseLoading]);
}

export function invalidatePayerCache() {
  payerListPromise = null;
}
